import React from 'react';
import PropTypes from 'prop-types';

import GenericTextBanner from '../GenericTextBanner';

export default class ProjectsMigratedBanner extends React.Component {
  constructor(props) {
    super(props);
    ProjectsMigratedBanner.propTypes = {
      text: PropTypes.string.isRequired,
    };
  }

  render() {
    return <GenericTextBanner text={this.props.text} hasCloseButton={true} isCompanyBanner={true} bannerType={this.props.bannerType} />;
  }
} 



// WEBPACK FOOTER //
// ./src/components/banners/ProjectsMigratedBanner/index.js